module.exports = __webpack_public_path__ + "img/unionpay.a96af353.svg";